import { isObject } from 'lodash';
export default function getUserPostInfo(user) {
    if (isObject(user)) {
        return user.user_id || user.email || user.mobile_number;
    }
    return '';
}
